<template>
  <div class="balance py-6 px-8">
    <h-header back="../payments" />

    <h-loading v-if="isLoading" />

    <div v-show="!isLoading">
      <div v-for="invoice in hostInvoices" :key="invoice.month_name" class="pa-5">
        <p class="headline mb-0 font-weight-light mb-2">
          {{ invoice.month_name }}
        </p>

        <HostInvoiceFortnight
          v-if="isNotEmpty(invoice.first_half)"
          :fortnight="invoice.first_half"
          title="firstHalf"
        />

        <HostInvoiceFortnight
          v-if="isNotEmpty(invoice.second_half)"
          :fortnight="invoice.second_half"
          title="secondHalf"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { isObjectEmpty } from '@/util/helpers'
import HostInvoicePanel from '@/components/hostInvoice/HostInvoicePanel'
import HostInvoiceFortnight from '@/components/hostInvoice/HostInvoiceFortnight'

export default {
  name: 'HostInvoicesList',

  components: {
    HostInvoicePanel,
    HostInvoiceFortnight,
  },

  data() {
    return {
      id: this.$router.currentRoute.params.id
    }
  },

  computed: {
    ...mapGetters(['isLoading', 'hostInvoices']),
  },

  methods: {
    ...mapActions(['fetchHostInvoices']),

    isNotEmpty(object) {
      return !isObjectEmpty(object)
    },
  },

  mounted() {
    this.fetchHostInvoices(this.id)
  },
}
</script>
